module.exports = __webpack_public_path__ + "static/img/LEADWELL.b818ab2f.png";